import { hocHook } from "../../../@hoc/hoc-hook";
import { Article2 } from "./article2";

export default hocHook(Article2);
